﻿import { GuiAuswertung } from "./GuiAuswertung";
import { Chart } from "../chart-setup";
import { IChartData } from "../Interface/IChartData"

export class GuiAuswertungVerfahrenMengeMonat extends GuiAuswertung {
    chartKosten?: Chart;

    constructor() {
        super("GuiAuswertungAbfallMengeMonat");
    }

    draw() {

        const ctx = document.getElementById("chartKosten") as HTMLCanvasElement;
        if (this.chartKosten != undefined) {
            this.chartKosten.destroy();
        }

        const jsonData = (document.getElementById("jsonChartDataKosten") as HTMLInputElement).value;
        if (jsonData == undefined || jsonData === "null") { return; }

        const pieData = JSON.parse(jsonData) as IChartData;
        const data = {
            labels: pieData.labels,
            datasets: [{
                label: "Menge (t)",
                data: pieData.values,
                backgroundColor: "#044135",
                borderColor: "#044135",
                hoverOffset: 4
            }, ...(pieData.values2 && pieData.values2.length > 0 ? [{
                label: "Menge (t) Vorjahr",
                data: pieData.values2,
                backgroundColor: "#0CAD8E",
                borderColor: "#0CAD8E",
                hoverOffset: 4
            }] : [])]
        };
        const config = this.CreateLineConfig(data);

        this.chartKosten = new Chart(ctx, config);
    }


}
